import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../components/spinner";

const CatalogoOrdenesdeComprasAprob = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "CONCEPTO", textAlign: "center" },
    { label: "FECHA DE SOLICITUD", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    const { value } = e.target;

    setFilterFn({
      fn: (items) => {
        if (value === "") {
          return items;
        } else {
          return items.filter((x) => {
            const searchValue = value.toLowerCase();

            if (
              (props.tipo === 1 && x.idordenservicio.includes(searchValue)) ||
              (props.tipo === 0 && x.idordencompra.includes(searchValue)) ||
              (props.tipo !== 1 &&
                props.tipo !== 0 &&
                x.idordendonacion.includes(searchValue)) ||
              x.concepto.toLowerCase().includes(searchValue) ||
              moment.utc(x.fecha).format("DD/MM/YYYY").includes(searchValue)
            ) {
              return true;
            }
            return false;
          });
        }
      },
    });
  };

  const seleccionarOrdenesCompras = () => {
    let estatus = props.status;
    let tipo = props.tipo;

    let endpoint = `${op.conexion}/api/catalogo/ordenesdecompraaprob?idefiscal=${idefiscal}&status=${estatus}&tipo=${tipo}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var data = [];
          for (let i = 0; i < response.data.length; i++) {
            data.push({
              idproveedor: response.data[i].idproveedor,
              idcordinacion: response.data[i].idcordinacion,
              concepto: response.data[i].concepto,
              idordencompra: response.data[i].idordencompra,
              idordenservicio: response.data[i].idordenservicio,
              idordendonacion: response.data[i].idordendonacion,
              fecha: response.data[i].fecha,
              observaciones: response.data[i].observaciones,
              monto: response.data[i].monto,
              montoiva: response.data[i].montoiva,
              fechacrea: response.data[i].fecha_crea,
            });
          }
          setRecords(data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const selectOrden = () => {
    var idcordinacion = values[0].idcordinacion;
    var concepto = values[0].concepto;
    var idproveedor = values[0].idproveedor;
    var idordencompra = values[0].idordencompra;
    var idordenservicio = values[0].idordenservicio;
    var idordendonacion = values[0].idordendonacion;
    var fecha = values[0].fecha;
    var observaciones = values[0].observaciones;
    var monto = values[0].monto;
    var montoiva = values[0].montoiva;
    var fechacrea = values[0].fechacrea;

    blanquear();
    props.onHideAceptaOrdenes(
      idcordinacion,
      concepto,
      idproveedor,
      idordencompra,
      idordenservicio,
      idordendonacion,
      fecha,
      observaciones,
      monto,
      montoiva,
      fechacrea,
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);

    var idcordinacion = recordsAfterPagingAndSorting()[index].idcordinacion;
    var concepto = recordsAfterPagingAndSorting()[index].concepto;
    var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
    var idordencompra = recordsAfterPagingAndSorting()[index].idordencompra;
    var idordenservicio = recordsAfterPagingAndSorting()[index].idordenservicio;
    var idordendonacion = recordsAfterPagingAndSorting()[index].idordendonacion;
    var fecha = recordsAfterPagingAndSorting()[index].fecha;
    var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
    var monto = recordsAfterPagingAndSorting()[index].monto;
    var montoiva = recordsAfterPagingAndSorting()[index].montoiva;
    var fechacrea = recordsAfterPagingAndSorting()[index].fechacrea;

    var datos = [];
    datos.push({
      idcordinacion,
      concepto,
      idproveedor,
      idordencompra,
      idordenservicio,
      idordendonacion,
      fecha,
      observaciones,
      monto,
      montoiva,
      fechacrea,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarOrdenesCompras();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props && props.tipo
              ? props.tipo === 2
                ? "Orden de Donacion"
                : props.tipo === 1
                  ? "Orden de Servicio"
                  : "Seleccionar Ordenes de Compra"
              : "Seleccionar Ordenes de Compra"}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center" style={{ width: "100px" }}>
                      {props.tipo === 1
                        ? item.idordenservicio
                        : props.tipo === 0
                          ? item.idordencompra
                          : item.idordendonacion}
                    </td>
                    <td className="py-2 text-start" style={{ width: "250px" }}>
                      {item.concepto}
                    </td>
                    <td className="py-2 text-center" style={{ width: "150px" }}>
                      {moment.utc(item.fecha).format("DD/MM/YYYY")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={selectOrden}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoOrdenesdeComprasAprob;
